import { useQuery } from '@tanstack/react-query';
import API from '../api/api.base';
import { QueryKeys } from '../constants';

type WebinarLinksResponse = {
	onboardingLink: string;
	presaleLink: string;
};

export const useGetWebinarLinks = (enabled = true) => {
	return useQuery<WebinarLinksResponse>({
		queryKey: [QueryKeys.GET_WEBINAR_LINKS],
		queryFn: async () => {
			const response = await API.get('/api/webinar/links', {});

			const webinarLinks = response?.value;

			if (
				!webinarLinks?.onboardingLink ||
				!webinarLinks?.presaleLink
			) {
				throw new Error('Webinar links are unavailable');
			}

			return webinarLinks;
		},
		enabled,
	});
};
